// import { useState } from "react";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import CALENDER_ICON from "assets/icons/calender.svg";
import CLOCK_ICON from "assets/icons/clock.svg";
import styles from "./styles.module.scss";
import { DatePickerInputProps } from "./types";

// The time picker emits a bare "HH:mm:ss", which dayjs cannot parse on its own
// (that needs the customParseFormat plugin, which this project doesn't load).
// Anchor it to a reference date so the value round-trips instead of rendering
// as "Invalid Date".
const parseValue = (value: DatePickerInputProps["value"]) => {
  if (!value) return undefined;
  if (typeof value === "string" && /^\d{1,2}:\d{2}(:\d{2})?$/.test(value)) {
    const time = value.length <= 5 ? `${value}:00` : value;
    return dayjs(`1970-01-01T${time.padStart(8, "0")}`);
  }
  return dayjs(value);
};

export default function DatePickerInput({
  onChange,
  value,
  picker = "date",
  shouldShowTime = false,
  disabled,
}: DatePickerInputProps) {
  // const [isHovering, setisHovering] = useState(false);
  return (
    <DatePicker
      className={styles.datePicker}
      allowClear = {!!value}
      onChange={(date, dateString) => {
        onChange?.(date ? (dateString as string) : "");
      }}
      value={parseValue(value)}
      onKeyDown={(e) => {
        if ((e.key === "Backspace" || e.key === "Delete") && value) {
          e.preventDefault();
          onChange?.("");
        }
      }}
      picker={picker}
      // // @ts-ignore
      // value={value}
      disabled={disabled}
      showTime={shouldShowTime}
      suffixIcon={
        !value ? <img
          className={styles["calender-icon"]}
          src={picker === "time" ? CLOCK_ICON : CALENDER_ICON}
          alt="calender"
        /> : null
      }
    />
  );
}
